<template>
  <div class="scale-container">
    <div v-for="(scale, index) in scales" :key="`scale-${index}`" class="scale-wrapper">
      <div class="title">
        {{ $t(scale.title) }}
      </div>
      <vv-scale
        :from="scale.from || 0"
        :to="scale.to || 5"
        :value="expectedResponse.choices[index].value"
        disabled
      />
    </div>
  </div>
</template>

<script>
import { VvScale } from '@/components/common'

export default {
  name: 'Scale',
  components: { VvScale },
  props: {
    scaleType: String,
    expectedResponse: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      scalesByType: {
        scaleTaninsCorpsAlcool: [
          {
            title: 'tasting.scale.tanins.title',
            description: 'tasting.scale.tanins.description'
          },
          {
            title: 'tasting.scale.corps.title',
            description: 'tasting.scale.corps.description'
          },
          {
            title: 'tasting.scale.alcool.title',
            description: 'tasting.scale.alcool.description'
          }
        ],
        scaleAciditeAromesSucrosite: [
          {
            title: 'tasting.scale.acidite.title',
            description: 'tasting.scale.acidite.description'
          },
          {
            title: 'tasting.scale.aromes.title',
            description: 'tasting.scale.aromes.description'
          },
          {
            title: 'tasting.scale.sucrosite.title',
            description: 'tasting.scale.sucrosite.description'
          }
        ]
      }
    }
  },
  computed: {
    scales() {
      if (!this.scaleType) return []

      return this.scalesByType[this.scaleType]
    }
  }
}
</script>

<style lang="scss" scoped>
.scale-wrapper {
  margin-bottom: 8px;
  text-align: left;

  .title {
    margin-bottom: 6px;
  }
}
</style>
